import { routes } from "./routes";

export const redirect = (url: string): void => {
  window.kivra.navigate(url);
};

const removeSlashFromEnd = (str: string): string =>
  str.endsWith("/") && str.length > 1 ? str.slice(0, -1) : str;

export const getTunnistusPath = (location: Location): string =>
  location.origin + "/tunnistus";

export const getPasswordResetPath = (location: Location): string =>
  location.origin + "/password-reset";

export const getSearch = (location: Location): string =>
  removeSlashFromEnd(location.search);

export const getPathname = (location: Location): string =>
  removeSlashFromEnd(location.pathname);

export const getWithoutSearch = (location: Location): string =>
  location.origin + location.pathname;

export const isTunnistusReturnPath = (location: Location): boolean =>
  getPathname(location) === routes.TUNNISTUS_RETURN;
const isSignupFormPath = (location: Location): boolean =>
  getPathname(location) === routes.SIGNUP_FORM_V2;
const isSignupTooYoungPath = (location: Location): boolean =>
  getPathname(location) === routes.SIGNUP_TOO_YOUNG;
export const isSignupAfterStrongAuthPath = (location: Location): boolean =>
  isSignupFormPath(location) || isSignupTooYoungPath(location);
export const isStrongAuthReturn = (location: Location): boolean =>
  isTunnistusReturnPath(location) || isPasswordResetReturnPath(location);

export const isPasswordResetReturnPath = (location: Location): boolean =>
  getPathname(location) === routes.PASSWORD_RESET_RETURN;
